var _this = this;
import * as tslib_1 from "tslib";
import { orchestrator } from 'satcheljs';
import outlookFavoritePersonasLoaded from '../../actions/v2/people/outlookFavoritePersonasLoaded';
import { outlookFavoritePersonaSearchFoldersLoaded } from 'owa-folders';
import { fetchMultipleFavoritePersonaSearchFolders } from 'owa-mail-persona-search-folder-services';
export default orchestrator(outlookFavoritePersonasLoaded, function (actionMessage) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
    var personas, searchFolderIdsForPersonas, existingFolders;
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                personas = actionMessage.personas;
                searchFolderIdsForPersonas = personas
                    .map(function (persona) { return persona.searchFolderId; })
                    .filter(function (searchFolderId) { return !!searchFolderId; });
                return [4 /*yield*/, fetchMultipleFavoritePersonaSearchFolders(searchFolderIdsForPersonas)];
            case 1:
                existingFolders = _a.sent();
                outlookFavoritePersonaSearchFoldersLoaded(existingFolders, personas);
                return [2 /*return*/];
        }
    });
}); });
//# sourceMappingURL=onFavoritesLoadedOrchestrator.js.map